// src/AMCComponents/AMCLandingPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';

const AMCLandingPage = () => {
    const navigate = useNavigate();
    
    // Get user role to show different content
    const userRole = sessionStorage.getItem('userRole');
    const isAdmin = userRole === 'admin' || userRole === 'superadmin';

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Annual Maintenance Contract (AMC)</h1>
            <p style={styles.description}>
                {isAdmin 
                    ? "Manage all AMC schedules and checklists. You can view all user activities and manage the system."
                    : "Manage your service contracts efficiently. You can view, schedule, and track your maintenance requests here."
                }
            </p>
            <div style={styles.buttonContainer}>
                <button style={styles.button} onClick={() => navigate('/amc/schedule/new')}>
                    Schedule a New AMC
                </button>
                <button style={styles.button} onClick={() => navigate('/amc/schedule/list')}>
                    View AMC Schedules
                </button>
                {isAdmin && (
                    <button style={styles.button} onClick={() => navigate('/amc/checklist/admin')}>
                        Manage Checklists
                    </button>
                )}
                <button style={styles.button} onClick={() => navigate('/amc/checklist/user')}>
                    View My Checklists
                </button>
            </div>
        </div>
    );
};

const styles = {
    container: {
        textAlign: 'center',
        padding: '3rem',
    },
    heading: {
        fontSize: '2.5rem',
        marginBottom: '1rem',
    },
    description: {
        fontSize: '1.2rem',
        marginBottom: '2rem',
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        alignItems: 'center',
    },
    button: {
        fontSize: '1rem',
        padding: '0.75rem 1.5rem',
        backgroundColor: '#007BFF',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        minWidth: '200px',
    },
};

export default AMCLandingPage;
